import React from "react";
import { Product } from "../types/Product";
import fallback from "../assets/Image-not-found.png";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface ProductCardProps {
  number: number;
  product: Product;
  handleChange: (id: string, actions: "add" | "minus", number: number) => void;
  className?: string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  number,
  product,
  handleChange,
  className = "",
}) => {
  const handleAdd = () => handleChange(product.id, "add", 1);
  const handleMinus = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    handleChange(product.id, "minus", 1);
  };

  return (
    <Box>
      <Card
        onClick={handleAdd}
        sx={{ width: 120, cursor: "pointer", boxShadow: 1 }}
        className={className}
      >
        <Box sx={{ position: "relative", height: 120 }}>
          <CardMedia
            component="img"
            image={product?.image || fallback}
            alt={product.name}
            onError={(e: any) => (e.currentTarget.src = fallback)}
            sx={{ width: "100%", height: "100%", objectFit: "contain" }}
          />

          {number > 0 && (
            <Box
              sx={{
                position: "absolute",
                left: 6,
                right: 6,
                bottom: 6,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 0.5,
                bgcolor: "rgba(255,255,255,0.9)",
                borderRadius: 1,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <IconButton size="small" onClick={handleMinus}>
                <RemoveIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="body2"
                sx={{ minWidth: 20, textAlign: "center" }}
              >
                {number}
              </Typography>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAdd();
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
      </Card>
      <Box
        sx={{
          py: 0.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="body2">{product.name}</Typography>
        <Typography variant="body2" sx={{ ml: 1 }}>
          ${product.price}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProductCard;
